export class UnprocessableContentResponse {
    public static readonly status = 422;

    public static error(message: string, options?: ErrorOptions) {
        return new UnprocessableContentResponse.Error(message, options);
    }

    public static Error = class UnprocessableContent extends Error {
        constructor(message = '422 Unprocessable Content', options?: ErrorOptions) {
            super(message, options);

            this.name = 'UnprocessableContent';

            Object.setPrototypeOf(this, UnprocessableContent.prototype);

            if (Error.captureStackTrace) {
                Error.captureStackTrace(this, UnprocessableContent);
            }
        }
    };
}
